export default () => ({
  isSerialized: false,
  response: {
    activities: [],
    clients: [],
    practitioners: [],
  },
})
